/* eslint-disable no-console */

import { register } from "register-service-worker";
import store from "./store";

// 開きっぱなしのタブでも新しいデプロイを検知できるよう、この間隔でSWの更新確認をポーリングする
const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

// updated()で新SWがwaiting状態になったregistrationを保持し、
// ユーザーが更新を承認したタイミングでapplyUpdate()から参照する
let waitingRegistration: ServiceWorkerRegistration | null = null;

// ユーザーが確認モーダルで更新を承認したときに呼び出す。
// 新SWにSKIP_WAITINGを送るとactivateされ、controllerchangeで強制リロードされる
export function applyUpdate(): void {
  if (!waitingRegistration || !waitingRegistration.waiting) return;
  waitingRegistration.waiting.postMessage({ type: "SKIP_WAITING" });
}

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  // 新SWがactivateされるとcontrollerchangeが発火するので、
  // それを合図にページを強制リロードして最新モジュールを取り込む
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      setInterval(() => {
        registration.update();
        // キャンセルされていても、更新が未適用のまま残っている限りは
        // ポーリングのたびに再度ダイアログを出し、開きっぱなしのタブにも通知する
        if (waitingRegistration) {
          store.dispatch("setNewVersionAvailable", true);
        }
      }, UPDATE_CHECK_INTERVAL_MS);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; asking user to apply update.");
      waitingRegistration = registration;
      store.dispatch("setNewVersionAvailable", true);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
